import container from 'src/container';
import useSWR from 'swr';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';
import {
    UserRole,
    getOrganizationId,
    getPrimaryRole,
    isOrganizationAdministrator,
} from 'src/domain/user';

const {
    cradle: { munduClient },
} = container;

type UseConsumersOptions = {
    organizationId?: string;
    enabled?: boolean;
    applyCreatorFilter?: boolean;
};

export const useConsumers = (options?: UseConsumersOptions) => {
    const user = useSignedInUser();
    const userId = user?.id;
    const role = getPrimaryRole(user);
    const isCreator =
        role === UserRole.creator && !isOrganizationAdministrator(user);
    const defaultOrganizationId = user ? getOrganizationId(user) : undefined;

    const organizationId = options?.organizationId ?? defaultOrganizationId;
    const enabled =
        typeof options?.enabled === 'boolean'
            ? options.enabled
            : Boolean(userId && organizationId);
    const shouldApplyCreatorFilter =
        Boolean(userId) &&
        isCreator &&
        (options?.applyCreatorFilter ?? !options?.organizationId);

    const swrKey =
        enabled && organizationId ? ['consumers', organizationId] : null;

    const { data, error, mutate } = useSWR(swrKey, () =>
        munduClient.listConsumers({
            organizationId,
            ...(shouldApplyCreatorFilter ? { creatorId: userId } : {}),
        }),
    );

    return {
        consumers: data || [],
        mutate,
        isLoading: Boolean(enabled) && !error && !data,
        isError: error,
    };
};
